import api from './api';

// Get all shooting schedules for a project
export const getShootingSchedules = async (projectId) => {
  try {
    const response = await api.get(`/shooting-schedules/project/${projectId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching shooting schedules:', error);
    throw error;
  }
};

// Get a specific shooting schedule by ID
export const getShootingScheduleById = async (scheduleId) => {
  try {
    const response = await api.get(`/shooting-schedules/${scheduleId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching shooting schedule:', error);
    throw error;
  }
};

// Create a new shooting schedule
export const createShootingSchedule = async (scheduleData) => {
  try {
    const response = await api.post(`/shooting-schedules`, scheduleData);
    return response.data;
  } catch (error) {
    console.error('Error creating shooting schedule:', error);
    throw error;
  }
};

// Update a shooting schedule
export const updateShootingSchedule = async (scheduleId, scheduleData) => {
  try {
    const response = await api.put(`/shooting-schedules/${scheduleId}`, scheduleData);
    return response.data;
  } catch (error) {
    console.error('Error updating shooting schedule:', error);
    throw error;
  }
};

// Delete (archive) a shooting schedule
export const deleteShootingSchedule = async (scheduleId) => {
  try {
    const response = await api.delete(`/shooting-schedules/${scheduleId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting shooting schedule:', error);
    throw error;
  }
};

// Generate a shooting schedule from scenes
export const generateShootingSchedule = async (projectId, scheduleData) => {
  try {
    const response = await api.post(`/shooting-schedules/generate/${projectId}`, scheduleData);
    return response.data;
  } catch (error) {
    console.error('Error generating shooting schedule:', error);
    throw error;
  }
};

// Preferences: load/save per-project manual selections
export const getSchedulePrefs = async (projectId) => {
  try {
    const response = await api.get(`/shooting-schedules/prefs/${projectId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching shooting schedule prefs:', error);
    throw error;
  }
};

export const saveSchedulePrefs = async (projectId, prefs) => {
  try {
    const response = await api.put(`/shooting-schedules/prefs/${projectId}`, prefs);
    return response.data;
  } catch (error) {
    console.error('Error saving shooting schedule prefs:', error);
    throw error;
  }
};
